export class AccountManager {
    constructor(
        public id: number,
        public name: string,
        public email: string,
        public location?: string
    ) { }
}
